// extracted by mini-css-extract-plugin
export default {"icon":"_5e4ec6c9"};